import { FC } from 'react';
import Header from '../components/Layout/Header';
import Footer from '../components/Layout/Footer';
/* import BackToTop from '../components/UI/BackToTop'; */
import Hero from '../components/Sections/Hero';
import Achievements from '../components/Sections/Achievements';
import Career from '../components/Sections/Career';
import Talks from '../components/Sections/Talks';
import Projects from '../components/Sections/Projects';
import Contact from '../components/Sections/Contact';
import About from './Sections/About';
import NextDevsAcademy from './Sections/NextDevsAcademy';

const Home: FC = () => {
  return (
    <div className="flex flex-col min-h-screen bg-[#0a0a0a] text-gray-100">
      <Header />
      <main className="flex-grow">
        <div className="flex flex-col ">
          <Hero />
          <About />
          <Achievements />
          <Career />
          <NextDevsAcademy/>
          <Projects />
          <Contact />
        </div>
      </main>
      <Footer />
    {/*   <BackToTop /> */}
    </div>
  );
};

export default Home;